export class CompareHelper {
  public static getDifferences<T>(a: T, b: T, ignore: string[]): Partial<T> {
    const differences: Partial<T> = {};
    const areEqual = (key: keyof T) => {
      if (Array.isArray(a[key]) && Array.isArray(b[key])) {
        return a[key].length === b[key].length;
      }
      return a[key] === b[key];
    };

    for (const key in a) {
      const typedKey = key as keyof T;
      if (!ignore.includes(key) && !areEqual(typedKey)) {
        differences[typedKey] = b[typedKey];
      }
    }

    return differences;
  }
}
